export enum SendToCirOption {
  Yes = "Yes",
  No = "No",
}

export enum EInvoiceStatus {
  Draft = 0,
  Sent = 1,
  Approved = 2,
  Rejected = 3,
  Cancelled = 4,
}
export interface EInvoiceResponse {
  invoiceId: string;
  purchaseInvoiceId: number;
  salesInvoiceId: number;
  eInvoiceStatus: EInvoiceStatus;
}

export interface SalesInvoiceRequest {
  status?: string;
}

export interface EntityInfo {
  entityName: string;
  type: string;
  entityId: number;
  additionalEntityId: number;
}

export interface SalesInvoice {
  salesInvoiceId: number;
  planId: number;
  entity: EntityInfo;
  customerFullName: string;
  priceTotal: number;
  status: string;
  type: number;
}

export interface SalesInvoiceResponse {
  salesInvoiceIds: SalesInvoice[];
}
export interface StornoRequestDto {
  invoiceId: number;
  planId: number;
  stornoComment: string;
  isPayment?: boolean;
  type?: string;
}

export interface TaxCategory {
  id: number;
  title: string;
  taxType: string;
  taxLabel: string;
  code: string;
  percentage: number;
  desicionNumber: string;
  description: string;
  saleType?: string;
  ID: string;
}
export interface UBLInvoiceToAddRequestDto {
  requestId: string;
  sendToCir: "Yes" | "No";
  executeValidation: boolean;
  invoiceId: number;
  amount: number;
  initialAmount: number;
  taxCategory?: TaxCategory;
  taxExemptionReasonCode?: string;
  taxExemptionReason?: string;
  contractNumber: string | undefined;
  descriptionCode?: number;
  type?: string;
  actualDeliveryDate?: string;
  dueDate: string | null;
}
export interface CompanyDto {
  bugetCompanyNumber: string;
  registrationCode: string;
  vatRegistrationCode: string;
  name: string;
  registrationDate: string;
  deletionDate: string;
}
export interface PdfData {
  pdfData: string;
  success: boolean;
}
export interface CheckCompanyRegistrationRequest {
  registrationNumber: string;
  jbkjs: string;
  vatNumber: string;
}

export interface CheckCompanyRegistrationResponse {
  eFakturaRegisteredCompany: boolean;
}
export interface ReverseChargeReason {
  reasonId: number;
  key: string;
  law: string;
  article: string;
  paragraph: string;
  point: string;
  subpoint: string;
  text: string;
  freeFormNote: string;
  activeFrom: string;
  activeTo: string | null;
  category: string;
}

export interface EInvoice {
  requestId: string;
  sendToCir: SendToCirOption;
  executeValidation: boolean;
  invoiceId: number;
  amount: number;
  initialAmount: number;
  taxCategory?: TaxCategory;
  contractNumber: string | undefined;
  type?: string;
  actualDeliveryDate?: string;
  dueDate: string | null;
}
